<template>
  <div class="progress-bar fixed-bottom d-flex flex-row">

    <!-- Note, this v-for indexing magic is 1-indexed !? -->
    <div class="d-flex flex-row" v-for="bullet in total" :key="bullet">
      <div class="bullet">
        <div class="bullet-image">
          <img v-if="index == bullet - 1" src="@/assets/placeholders/bullet-active.svg" :alt="bullet">
          <img v-else src="@/assets/placeholders/bullet.svg" :alt="bullet">
        </div>
        <div class="label">{{ bullet }}</div>
      </div>

      <div v-if="bullet < total" class="bar d-flex "><img src="@/assets/placeholders/bar.svg" alt="bar"></div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
  .progress-bar {
    margin: 0 auto;
    background-color: #322984;
    max-width: 600px;
    z-index: 0;
    padding-bottom: 16px;
    @media (max-width: 768px) {
      max-width: 500px;
    }
    @media (max-width: 576px) {
      padding: 20px 16px 12px 16px;
      width: 100%;
      background-color: #28286e;
    }
  }

  .bullet {
    .bullet-image {
      width:32px;
      height: 32px;
    }
  }
  .bar {
    margin-top:14px;
    background-color: #fff;
    height: 4px;
    img {
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/quiz/QuizProgress.vue